<template>
  <div>
    <!-------------------------------- 漫游点编辑 -------------------------------------------->
    <MapModal
      :modalNode="modalNode"
      :submitData="submitData"
      :submit="submit"
      :close="close"
      :title="roamingTitle"
      id="roamingAdit"
    ></MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import * as mapWork from "../map";
import { addBimVideoRoamingNode, editBimVideoRoamingNode } from "@/api/api";
export default {
  name: "roaming-point-edit",
  components: {
    MapModal,
  },
  computed: {},
  props: [
    "roamingPointSubmit",
    "roamingTitle",
    "close",
    "initData",
    "videoList",
  ],
  data() {
    return {
      modalNode: {
        roamingRoaming: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -706,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "form",
            formData: {
              name: {
                md: 24,
                type: "input",
                title: "名称",
                placeholder: "请输入",
              },
              position: {
                md: 24,
                type: "button",
                title: "标点",
                buttonTitle: "选点",
                click: this.pickPoint,
                show: true,
              },
              newurl: {
                type: "select",
                title: "新视频",
                placeholder: "请选择",
                options: [
                  // {
                  //   name: "视频1",
                  //   id: "/video/1.mp4",
                  //   surveilType: "directory",
                  // },
                  // {
                  //   name: "视频2",
                  //   id: "/video/2.mp4",
                  //   surveilType: "directory",
                  // },
                ],
              },
              oldurl: {
                type: "select",
                title: "老视频",
                placeholder: "请选择",
                options: [
                  // {
                  //   name: "视频1",
                  //   id: "/video/1.mp4",
                  //   surveilType: "directory",
                  // },
                  // {
                  //   name: "视频2",
                  //   id: "/video/2.mp4",
                  //   surveilType: "directory",
                  // },
                ],
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              // position: [
              //   {
              //     required: true,
              //     message: "请在地图上标点",
              //     trigger: "blur",
              //   },
              // ],
              newurl: [
                {
                  required: true,
                  message: "请选择视频",
                  trigger: "blur",
                },
              ],
              oldurl: [
                {
                  required: true,
                  message: "请选择视频",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      submitData: {
        id: "",
        name: "",
        position: "",
        newurl: "",
        oldurl: "",
      },
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      mapWork.editRoamingPointsClose();
      mapWork.editVideoPointsClose();
      if (this.roamingTitle == "编辑漫游") {
        this.modalNode.roamingRoaming.content.formData.position.show = false;
      } else {
        this.modalNode.roamingRoaming.content.formData.position.show = true;
      }
      if (this.initData) {
        let { id, name, newurl, oldurl } = this.initData;
        this.submitData = {
          id: id,
          name: name,
          newurl: newurl,
          oldurl: oldurl,
        };
      }
      this.modalNode.roamingRoaming.content.formData.newurl.options = this.videoList;
      this.modalNode.roamingRoaming.content.formData.oldurl.options = this.videoList;
    },
    submit() {
      if (this.roamingTitle != "编辑漫游") {
        let bimVideoRoamingContent = [];
        JSON.parse(this.submitData.position).forEach((item, index) => {
          console.log(item);
          bimVideoRoamingContent.push({
            name: `坐标-${index}`,
            contentValue: JSON.stringify(item),
          });
        });
        addBimVideoRoamingNode({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          pId: 0,
          name: this.submitData.name,
          oldVideoUrl: this.submitData.oldurl,
          newVideoUrl: this.submitData.newurl,
          bimVideoRoamingContent: bimVideoRoamingContent,
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.close();
              this.$notify({
                title: "添加成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.$parent.init();
            } else {
              this.$notify({
                title: "请求失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((res) => {
            this.$alert("网络不佳，请求错误！！", "请刷新页面", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
          });
      } else {
        editBimVideoRoamingNode({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          pid: 0,
          id: this.submitData.id,
          name: this.submitData.name,
          oldVideoUrl: this.submitData.oldurl,
          newVideoUrl: this.submitData.newurl,
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.close();
              this.$notify({
                title: "编辑成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.$parent.init();
            } else {
              this.$notify({
                title: "请求失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((res) => {
            this.$alert("网络不佳，请求错误！！", "请刷新页面", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
          });
      }
    },
    pickPoint() {
      let position = [];
      let text = 1;
      mapWork.addRoamingPoints(null, {
        type: "all",
        text: text,
      });
      let _this = this;
      mapWork.graphicDotsine.on(mars3d.EventType.drawCreated, function(e) {
        let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
          e.graphic._position_draw
        );
        position.push([_lng, _lat, _alt]);
        text += 1;
        _this.submitData.position = JSON.stringify(position);
        mapWork.addRoamingPoints(null, {
          type: "all",
          text: text,
        });
      });
    },
  },
  watch: {
    initData: {
      handler(newData) {
        this.init();
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.table {
  margin: calc(100px + var(--x)) 0 0 calc(-735px + var(--y)) !important;
}
</style>
